import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import type { AuditLogResource } from "@wingspanhq/wingspan-api-sdk";
import { ResourceHistory } from "./index";

type Props = {
  resource: AuditLogResource;
  title: string;
  /**
   * The account the parent timeline was read from. A drill-down is the same
   * timeline narrowed to one resource, so it has to stay on the same account —
   * dropping it here would read the sub-resource from the caller's own account.
   */
  xWingspanAccount?: string;
} & WSModalCustomProps<void>;

const ModalResourceDrillDownHistory: React.FC<Props> = props => (
  <WSModal
    title={props.title}
    onClose={props.onClose}
    size="M"
    actions={{
      alignment: "fill",
      buttons: [
        { label: "Done", kind: "Tertiary", onClick: () => props.onClose() }
      ]
    }}
  >
    <WSText.ParagraphSm color="gray500" mb="XL">
      Here's the full item history:
    </WSText.ParagraphSm>
    <ResourceHistory
      resources={[props.resource]}
      xWingspanAccount={props.xWingspanAccount}
      bare
    />
  </WSModal>
);

export const useModalResourceDrillDownHistory = () =>
  useWSModalCustom(ModalResourceDrillDownHistory);
